import enquireJs from 'enquire.js'


export const DEVICE_TYPE = {
  DESKTOP: 'desktop', // pc端
  PAD: 'pad', // pad端
  PHONE: 'phone', // 手机端
};

export const deviceEnquire = function (callback) {
  const matchDesktop = {
    match: () => {
      callback && callback(DEVICE_TYPE.DESKTOP)
    }
  };

  const matchPad = {
    match: () => {
      callback && callback(DEVICE_TYPE.PAD)
    }
  };

  const matchPhone = {
    match: () => {
      callback && callback(DEVICE_TYPE.PHONE)
    }
  };

  enquireJs
    .register('screen and (max-width: 576px)', matchPhone)
    .register('screen and (min-width: 576px) and (max-width: 1199px)', matchPhone)
    .register('screen and (min-width: 1200px)', matchDesktop)
};



// WEBPACK FOOTER //
// ./src/utils/device.js